import { Partners } from 'utils/constants';

export const getLabels = (partner: Partners | string) => {
    switch (partner) {
        case Partners.REALME:
            return {
                label1: 'Select appliance',
                label2: 'Search appliance',
            };

        case Partners.XIAOMI:
            return {
                label1: 'Select Product Model',
                label2: 'Search model',
            };

        default:
            return {
                label1: 'Select Product Model',
                label2: 'Search mobile',
            };
    }
};
